/**
 * SN-7849 — the pending-invitations copy mobile Home already shows
 * (`PendingInvitationCard`, `PendingInvitationView`), for web Home's card and
 * popup. Defined once here; the web components read it from this file.
 */
export const pendingInvitationsCopy = {
  /** The card's title, as mobile's Home card words it. */
  cardTitle: (count: number): string =>
    `You Have ${count} Pending Invitation${count === 1 ? '' : 's'}`,
  /** The popup's title and lead line, as mobile's pending-invitation screen words them. */
  modalTitle: (count: number): string =>
    count === 1 ? 'Invitation Pending!' : `${count} Pending Invitations`,
  modalBody: (count: number): string =>
    count === 1
      ? 'Your League Is Waiting! Accept Your Invitation Now And Hit The Locker Room.'
      : "You've Got New Invitations Waiting! Review And Accept Them To Get Started.",
  /** Stands in for the names past the first two when there are more than three. */
  andMore: (count: number): string => `${count} more`,
  /** A row whose team or competition no longer names itself. */
  unnamed: 'Invitation',
  invitedBy: (sender: string): string => `Invited by ${sender}`,
  review: 'Review',
  notNow: 'Not Now',
  viewInvitations: 'View Invitations',
}
